import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyle from 'lib/styles/GlobalStyle';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import authReducer from 'modules/authSlice';
import dashboardReducer from 'modules/dashboardSlice';
import serviceReducer from 'modules/serviceSlice';
import contractReducer from 'modules/contractSlice';
import storeReducer from 'modules/storeSlice';
import deviceReducer from 'modules/deviceSlice';
import errorReducer from 'modules/errorSlice';
import notificationReducer from 'modules/notificationSlice';
import { QueryClient, QueryClientProvider } from 'react-query';

const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    service: serviceReducer,
    contract: contractReducer,
    store: storeReducer,
    device: deviceReducer,
    error: errorReducer,
    notification: notificationReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <GlobalStyle />
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
